const loadMoreBtn = document.getElementById("loadMoreBtn");
const thisArticle = document.querySelector(".article-template__comments-list");
const thisPagination = document.querySelector(".pagination__list");
const likeContainer = document.querySelector('.article-template__likes');
const likeBtn = likeContainer ? likeContainer.querySelector('.article-template__likes-icon') : null;
const articleId = likeContainer ? likeContainer.getAttribute('data-article-id') : null;
const likesCountEl = document.getElementById('likes-count');

function isUserLoggedIn() {
  const accountLinks = document.querySelectorAll('a[href*="/account"]');
  for (let link of accountLinks) {
    if (link.textContent.toLowerCase().includes('logout') || 
        link.textContent.toLowerCase().includes('đăng xuất') ||
        link.textContent.toLowerCase().includes('account')) {
      return true;
    }
  }
  
  return false;
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function getUserData() {
  const authorField = document.getElementById('CommentForm-author');
  const emailField = document.getElementById('CommentForm-email');
  
  if (authorField && emailField) {
    return {
      name: authorField.value || '',
      email: emailField.value || ''
    };
  }
  
  return {
    name: '',
    email: ''
  };
}

// Focus trap + scroll lock helpers for the login popup
let previouslyFocusedElement = null;
let accountPopupOpen = false;
let openedFromElement = null;
let focusTrapListener = null;

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

function trapFocus(container) {
  const focusables = getFocusableElements(container);
  if (focusables.length === 0) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  focusTrapListener = function (e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  document.addEventListener('keydown', focusTrapListener);

  // Move focus inside popup
  first.focus({ preventScroll: true });
}

function releaseFocus() {
  if (focusTrapListener) {
    document.removeEventListener('keydown', focusTrapListener);
    focusTrapListener = null;
  }
  // Avoid refocusing the comment textarea which would retrigger the popup
  const shouldSkipRefocus = previouslyFocusedElement && previouslyFocusedElement.id === 'CommentForm-body';
  if (previouslyFocusedElement && !shouldSkipRefocus) {
    previouslyFocusedElement.focus({ preventScroll: true });
  }
  previouslyFocusedElement = null;
  openedFromElement = null;
}

function showLoginPopup() {
  const accountPopup = document.querySelector('.account-popup');
  
  // Prevent opening multiple times
  if (accountPopupOpen) return;

  if (accountPopup) {
    previouslyFocusedElement = document.activeElement;
    openedFromElement = previouslyFocusedElement;
    accountPopup.classList.add('active');
    accountPopup.classList.add('show-login');
    accountPopup.setAttribute('data-form-type', 'login');
    document.body.classList.add('account-popup-open');
    accountPopupOpen = true;

    // Focus the first input/button in popup
    setTimeout(() => {
      trapFocus(accountPopup);
    }, 0);
  } else {
    window.open(loginUrl, 'login', 'width=500,height=600,scrollbars=yes,resizable=yes');
  }
}

// Optional: close popup utility if a close button exists
let isClosing = false;
function closeLoginPopup() {
  if (isClosing) return; // Prevent multiple calls
  isClosing = true;
  
  const accountPopup = document.querySelector('.account-popup');
  if (!accountPopup) {
    isClosing = false;
    return;
  }
  
  accountPopup.classList.remove('active');
  accountPopup.classList.remove('show-login');
  document.body.classList.remove('account-popup-open');
  releaseFocus();
  accountPopupOpen = false;
  
  // Reset flag after a short delay
  setTimeout(() => {
    isClosing = false;
  }, 100);
}

// Delegate close click if a close button exists
document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('[data-account-popup-close], .account-popup__close');
  if (closeBtn) {
    e.preventDefault();
    e.stopPropagation();
    closeLoginPopup();
  }
});

// Also handle ESC key to close popup
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const accountPopup = document.querySelector('.account-popup');
    if (accountPopup && accountPopup.classList.contains('active')) {
      e.preventDefault();
      closeLoginPopup();
    }
  }
});

function refreshCommentList() {
  const urlHash = window.location.hash;
  if (urlHash && urlHash.includes('CommentForm')) {
    const commentTextarea = document.getElementById('CommentForm-body');
    if (commentTextarea) {
      commentTextarea.value = '';
      const charCount = document.getElementById('char-count');
      if (charCount) {
        charCount.textContent = '0';
        charCount.style.color = 'rgba(186, 186, 190, 1)';
      }
    }
    
    const commentsSection = document.querySelector('.article-template__comments');
    if (commentsSection) {
      commentsSection.scrollIntoView({ behavior: 'smooth' });
    }
    
    window.history.replaceState(null, null, window.location.pathname);
  }
}

let currentPage = 1;
const commentsPerPage = 10;
let allComments = [];

function initializePagination() {
  const commentElements = document.querySelectorAll('.article-template__comments-comment');
  allComments = Array.from(commentElements);
  
  allComments.forEach(comment => comment.style.display = 'none');
  
  showPage(1);
  updateLoadMoreButton();
}

function showPage(page) {
  const endIndex = page * commentsPerPage;
  
  for (let i = 0; i < endIndex && i < allComments.length; i++) {
    allComments[i].style.display = 'block';
  }
  
  for (let i = endIndex; i < allComments.length; i++) {
    allComments[i].style.display = 'none';
  }
}

function loadMoreComments() {
  currentPage++;
  showPage(currentPage);
  updateLoadMoreButton();
}

function updateLoadMoreButton() {
  const totalPages = Math.ceil(allComments.length / commentsPerPage);
  const hasMorePages = currentPage < totalPages;
  
  if (hasMorePages) {
    loadMoreBtn.style.display = 'block';
  } else {
    loadMoreBtn.style.display = 'none';
  }
}

const commentForm = document.querySelector('form[action*="comments"]');
const commentTextarea = document.getElementById('CommentForm-body');

if (commentForm && commentTextarea) {
  const minPx = 64;
  const autoResize = (el) => {
    el.style.height = 'auto';
    const next = Math.max(minPx, el.scrollHeight);
    el.style.height = `${next}px`;
  };
  commentTextarea.style.height = `${minPx}px`;
  autoResize(commentTextarea);
  commentTextarea.addEventListener('input', () => autoResize(commentTextarea));
  
  commentTextarea.addEventListener('focus', function() {
    if (!isUserLoggedIn() && !accountPopupOpen) {
      showLoginPopup();
    } 
  });
  
  commentTextarea.addEventListener('click', function() {
    if (!isUserLoggedIn() && !accountPopupOpen) {
      showLoginPopup();
    }
  });
  
  commentForm.addEventListener('submit', function(e) {
    if (!isUserLoggedIn()) {
      e.preventDefault();
      showLoginPopup();
    } else {
      e.preventDefault(); 
      const submitBtn = commentForm.querySelector('input[type="submit"]');
      const originalValue = submitBtn.value;
      submitBtn.value = 'Đang gửi...';
      submitBtn.disabled = true;
      
      const formData = new FormData(commentForm);
      
      fetch(commentForm.action, {
        method: 'POST',
        body: formData
      })
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newComment = tempDiv.querySelector('.article-template__comments-comment');
        
        if (newComment) {
          const commentsList = document.querySelector('.article-template__comments-list');
          commentsList.insertBefore(newComment, commentsList.firstChild);
          
          allComments.unshift(newComment);
          currentPage = 1;
          showPage(currentPage);
          updateLoadMoreButton();
          
          commentForm.reset();
          
          const commentCount = document.querySelector('#Comments-' + articleId);
          if (commentCount) {
            const currentCount = parseInt(commentCount.textContent.match(/\d+/)[0]);
            commentCount.textContent = commentCount.textContent.replace(/\d+/, currentCount + 1);
          }
        }
        
        submitBtn.value = originalValue;
        submitBtn.disabled = false;
      })
      .catch(error => {
        console.error('Error submitting comment:', error);
        submitBtn.value = originalValue;
        submitBtn.disabled = false;
      });
    }
  }); 
}

  document.addEventListener('DOMContentLoaded', function() {
  refreshCommentList();
  
  setTimeout(() => {
    initializePagination();
  }, 100);
  if (likeBtn && articleId) {
    const countKey = `article_like_count_${articleId}`;
    const userLikedKey = `article_user_liked_${articleId}`;
    
    let count = localStorage.getItem(countKey);
    if (count === null) {
      count = Math.floor(Math.random() * (500 - 10 + 1)) + 10;
      localStorage.setItem(countKey, String(count));
    } else {
      count = parseInt(count, 10);
    }
    
    const userHasLiked = localStorage.getItem(userLikedKey) === '1';

    if (likesCountEl) likesCountEl.textContent = String(count);
    likeBtn.setAttribute('aria-pressed', userHasLiked ? 'true' : 'false');
  }
});

if (likeBtn && articleId) {
  likeBtn.addEventListener('click', function() {
    if (!isUserLoggedIn()) {
      showLoginPopup();
      return;
    }
    
    const countKey = `article_like_count_${articleId}`;
    const userLikedKey = `article_user_liked_${articleId}`;
    
    const current = likeBtn.getAttribute('aria-pressed') === 'true';
    const next = !current;
    
    likeBtn.setAttribute('aria-pressed', next ? 'true' : 'false');
    localStorage.setItem(userLikedKey, next ? '1' : '0');

    let count = parseInt(localStorage.getItem(countKey) || '0', 10);
    count = next ? count + 1 : Math.max(0, count - 1);
    localStorage.setItem(countKey, String(count));
    if (likesCountEl) likesCountEl.textContent = String(count);
  });
}

if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", loadMoreComments);
}